import m from "../../../../geodata/es2015/region/world/europeLow";
window.am4geodata_region_world_europeLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/europeLow.js
// module id = null
// module chunks = 